(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/results-draw-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/results-draw-selector.js');
"use strict";

const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  getDrawStateEnum,
  drawStateEnums
} = svs.components.sport.tipsenShared;
const ResultsDrawSelector = _ref => {
  let {
    draws,
    selectedDraw
  } = _ref;
  const history = useHistory();
  const location = useLocation();
  const [productBranding] = useBranding();
  const selectedItem = selectedDraw;
  if (!draws || draws.length <= 1) {
    return null;
  }
  return React.createElement(ItemsMenu, {
    branding: "side-nav",
    className: "side-nav-menu side-nav-menu--".concat(productBranding),
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, draws.map((draw, index) => React.createElement(LinkItem, {
    badge: true,
    badgeNr: getDrawStateEnum(draw.drawStateId) === drawStateEnums.LIVE ? 'Live' : '',
    Component: "div",
    key: "".concat(draw === null || draw === void 0 ? void 0 : draw.drawNumber, "-").concat(draw === null || draw === void 0 ? void 0 : draw.productId, "-").concat(draw === null || draw === void 0 ? void 0 : draw.date),
    label: "Omg\xE5ng ".concat(index + 1),
    onClick: () => {
      history.replace("".concat(location.pathname, "?draw=").concat(draw.drawNumber, "&product=").concat(draw === null || draw === void 0 ? void 0 : draw.productId));
    },
    selected: selectedItem === "".concat(draw === null || draw === void 0 ? void 0 : draw.drawNumber, "-").concat(draw === null || draw === void 0 ? void 0 : draw.productId)
  })));
};
setGlobal('svs.components.tipsen.routeResult.ResultsDrawSelector', ResultsDrawSelector);

 })(window);